import { createApp } from 'vue'
import { router } from '@/router'
import App from './App.vue'
import "@/styles/index.stylus"
import iTitle from './components/iTitle.vue'
import { components, plugins } from '@/utils/element'
import '@/utils/head'

const app = createApp(App)


components.forEach(component => {
  app.component(component.name, component)
})
plugins.forEach(plugin => {
  app.use(plugin)
})
app.component('i-title', iTitle)

app.use(router)
app.mount('#app')
